const fontFamily = "'Inter', sans-serif";

export const typography = {
  fontFamily,

  // Tier 1 — Display (website big titles)
  display: {
    xl: { fontFamily, fontSize: "56px", fontWeight: 700, lineHeight: 1.1 },
    l: { fontFamily, fontSize: "48px", fontWeight: 700, lineHeight: 1.2 },
    m: { fontFamily, fontSize: "40px", fontWeight: 700, lineHeight: 1.2 }
  },

  // Tier 3 — Heading (page titles, section titles)
  heading: {
    xl: { fontFamily, fontSize: "32px", fontWeight: 700, lineHeight: 1.2 },
    l: { fontFamily, fontSize: "24px", fontWeight: 700, lineHeight: 1.25 },
    lSemibold: {
      fontFamily,
      fontSize: "24px",
      fontWeight: 600,
      lineHeight: 1.25
    },
    m: { fontFamily, fontSize: "20px", fontWeight: 700, lineHeight: 1.35 },
    s: { fontFamily, fontSize: "18px", fontWeight: 600, lineHeight: 1.45 },
    sRegular: {
      fontFamily,
      fontSize: "18px",
      fontWeight: 400,
      lineHeight: 1.45
    }
  },

  // Tier 2 — Body (body text, inputs, labels)
  body: {
    xxl: { fontFamily, fontSize: "20px", fontWeight: 400, lineHeight: 1.35 },
    xxlBold: {
      fontFamily,
      fontSize: "20px",
      fontWeight: 700,
      lineHeight: 1.35
    },
    xl: { fontFamily, fontSize: "18px", fontWeight: 400, lineHeight: 1.45 },
    xlBold: { fontFamily, fontSize: "18px", fontWeight: 700, lineHeight: 1.45 },
    xlSemibold: {
      fontFamily,
      fontSize: "18px",
      fontWeight: 600,
      lineHeight: 1.45
    },
    l: { fontFamily, fontSize: "16px", fontWeight: 400, lineHeight: 1.5 },
    lBold: { fontFamily, fontSize: "16px", fontWeight: 700, lineHeight: 1.5 },
    lSemibold: {
      fontFamily,
      fontSize: "16px",
      fontWeight: 600,
      lineHeight: 1.5
    },
    m: { fontFamily, fontSize: "14px", fontWeight: 400, lineHeight: 1.6 },
    mBold: { fontFamily, fontSize: "14px", fontWeight: 700, lineHeight: 1.6 },
    s: { fontFamily, fontSize: "12px", fontWeight: 400, lineHeight: 1.65 },
    sSemibold: {
      fontFamily,
      fontSize: "12px",
      fontWeight: 600,
      lineHeight: 1.65
    }
  }
};
